/* eslint-disable */
import React, { Component } from "react";
import { Box, Circle, Heading, HStack, Text, Image } from "@chakra-ui/react";
import { Link } from "react-scroll";
import { useTranslation, withTranslation, Trans } from "react-i18next";

export default function LeftMenu(props: any) {
  const { t, i18n } = useTranslation();

  return (
    <Box
      pos="fixed"
      float="left"
      w="20vw"
      ml={10}
      mt={10}
      h="60vh"
      borderLeftRadius="20px"
      display={["none", "none", "block"]}
    >
      {props.data.map((section: any, index: number) => (
        <Box maxW="20rem" mb={4} key="identification">
          <HStack cursor="pointer">
            <Circle
              w="36px"
              borderWidth="3px"
              borderColor="brand.bf3"
              color="brand.white"
              fontSize="20px"
              fontWeight="600"
              bg="brand.bf3"
            >
              {index + 1}
            </Circle>
            <Heading
              fontSize="20px"
              fontFamily="Inter, sans-serif"
              color="brand.bf3"
              mb={2}
            >
              {t(`distributor:${section.label}`)}
            </Heading>
            <Image src="/icon/check-circle.svg" />
          </HStack>
          {section.subSection.map((sub: any) => (
            <div key={section.id}>
              <Text
                style={{ cursor: "pointer" }}
                ml={10}
                mb={2}
                color="brand.bf3"
                fontFamily="Inter, sans-serif"
              >
                <Link
                  activeClass="is-current"
                  to={sub.id}
                  containerId="middle-menu"
                  spy={true}
                  smooth={true}
                  duration={500}
                  offset={-10}
                >
                  {t(`distributor:${sub.label}`)}
                </Link>
              </Text>
            </div>
          ))}
        </Box>
      ))}
    </Box>
  );
}
